'use strict';

var ChartDashboardScheduleDirective = function ChartDashboardScheduleDirective(Chart) {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-schedule.html'),
    controller: 'ChartDashboardScheduleController',
    scope: {
      screen: '@',
      mode: '@'
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, $scope.chartFormatters);
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
      $scope.setChartVisibility = function (show) {
        element.toggle(show);
      };
      $scope.$on('brush-filter:filterApplied', $scope.checkVisibilityAndReload);
      $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', $scope.checkVisibilityAndReload);
    }
  };
};
ChartDashboardScheduleDirective.$inject = ['ChartDashboardSchedule'];
module.exports = ChartDashboardScheduleDirective;